export default __webpack_public_path__ + "static/CommSec-2b4b4479d2f1a560e728f4b45fc48c11.png";